import { createTheme } from "@mui/material";

export const BaseTheme = createTheme({
  typography: {
    fontFamily: "Lexend, sans-serif",
    fontWeightRegular: 400,
    fontWeightLight: 300,
    fontWeightMedium: 600,
    fontWeightBold: 800,
  },
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: "#505050",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        text: {
          textTransform: "none",
        },
      },
      variants: [
        {
          props: { variant: "contained", color: "primary" },
          style: {
            textTransform: "none",
          },
        },
        {
          props: { variant: "outlined", color: "primary" },
          style: {
            textTransform: "none",
          },
        },
      ],
    },
  },
});
